<template>
  <div class="router-transitions container-fluid flex-grow-1 map-home">
    <router-view></router-view>
    <div v-if="$route.name === 'map-home'" class="p-5 text-big">You need to create and publish at least one floor...</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { whenFloorsLoaded } from '@/components/map/mapRoute'
import { redirectLocation } from '@/router/navigation'

// a bare /map opens the first published floor, and /map is never an entry of its own that
// back would land on only to be sent to the floor again - see redirectLocation
const redirectToMap = (to, from, next) => {
  if (to.name !== 'map-home') return next()

  whenFloorsLoaded(() => {
    const floor = store.getters['floor/floors'].find((floor) => +floor.status)
    floor ? next(redirectLocation(to, { name: 'map', params: { floorId: floor.id } })) : next()
  })
}

export default {
  name: 'map-home',
  computed: {
    ...mapGetters('floor', ['floors'])
  },
  beforeRouteUpdate(to, from, next) {
    redirectToMap(to, from, next)
  },
  beforeRouteEnter(to, from, next) {
    redirectToMap(to, from, next)
  }
}
</script>

<style scoped>
.map-home {
  padding: 0 !important;
  background: #fff;
}

.empty-message {
}
</style>
